import React from 'react';
import { motion } from 'framer-motion';
import { FaCode, FaPaintBrush, FaGlobe, FaGraduationCap } from 'react-icons/fa';

const About = () => {
  const techStack = [
    { name: 'React Native', category: 'Mobile' },
    { name: 'Next.js', category: 'Web' },
    { name: 'MERN Stack', category: 'Full-Stack' },
    { name: 'Laravel', category: 'Backend' },
    { name: 'Python', category: 'Automation' },
    { name: 'Vercel', category: 'Deployment' },
  ];

  return (
    <section id="about" className="section-padding relative overflow-hidden">
      <div className="container mx-auto max-w-6xl">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left: Bio & Education */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-4xl md:text-5xl font-bold mb-8">
              Expertise & <span className="text-gradient">Vision</span>
            </h2>
            
            <div className="space-y-6 text-white/70 text-lg leading-relaxed">
              <p>
                I am a dedicated <span className="text-white font-medium">Associate Software Engineer</span> with a <span className="text-white font-medium">BSc (Hons) in Software Engineering</span>. 
                My approach combines technical precision with creative problem-solving.
              </p>
              
              <div className="flex items-start gap-4 p-6 glass rounded-2xl border-white/5 hover:border-primary/20 transition-all group">
                <div className="p-3 rounded-xl bg-primary/10 text-primary group-hover:scale-110 transition-transform">
                  <FaGlobe size={24} />
                </div>
                <div>
                  <h4 className="text-white font-semibold mb-1">Global Reach</h4>
                  <p className="text-sm">Based in <span className="text-accent-cyan">Sri Lanka</span>, I provide high-end digital solutions for clients worldwide, ensuring seamless communication and delivery.</p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-6 glass rounded-2xl border-white/5 hover:border-accent-purple/20 transition-all group">
                <div className="p-3 rounded-xl bg-accent-purple/10 text-accent-purple group-hover:scale-110 transition-transform">
                  <FaPaintBrush size={24} />
                </div>
                <div>
                  <h4 className="text-white font-semibold mb-1">Creative Edge: VINOMI ARTS</h4>
                  <p className="text-sm">Beyond code, I run <span className="text-accent-purple italic">"VINOMI ARTS"</span>, my personal art business. This artistic background gives me a unique eye for design, color theory, and UI/UX aesthetics that most developers lack.</p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right: Tech Stack & Experience */}
          <div className="space-y-12">
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <h3 className="text-2xl font-bold mb-8 flex items-center gap-3">
                <FaCode className="text-primary" /> Core Tech Stack
              </h3>
              
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {techStack.map((tech, i) => (
                  <motion.div
                    key={i}
                    whileHover={{ scale: 1.05 }}
                    className="p-4 glass rounded-xl border-white/10 text-center hover:border-primary/30 transition-all"
                  >
                    <p className="text-white font-medium">{tech.name}</p>
                    <p className="text-[10px] uppercase tracking-widest text-white/40 mt-1">{tech.category}</p>
                  </motion.div>
                ))}
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="p-8 glass rounded-[2.5rem] border-white/10 relative overflow-hidden group"
            >
              <div className="absolute top-0 right-0 p-8 text-white/5 -rotate-12 group-hover:rotate-0 transition-all duration-700">
                <FaGraduationCap size={120} />
              </div>
              
              <h3 className="text-xl font-bold mb-4">Academic Excellence</h3>
              <p className="text-white/80 font-medium">BSc (Hons) in Software Engineering at Bermingham City University, UK</p>
              <p className="text-sm text-white/50 mt-1">First Class Honours Prospect</p>
              
              <div className="mt-6 flex items-center gap-2 text-accent-cyan text-sm">
                <span className="w-2 h-2 rounded-full bg-accent-cyan animate-pulse" />
                Continuously Evolving
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

